/*
 * @Description:
 * @Date: 2022-03-11 14:48:52
 * @LastEditTime: 2023-04-27 15:18:16
 */
import { Request } from "@/plugin/axios";
import api from "@/constant/api/console/model/product";
// 标准产品分页查询
export function getProdStandardList(data, params) {
  return Request(api.getProdStandardList, api.getProdStandardList.url, data, params);
}
// 自定义产品分页查询
export function getProdCustomList(data, params) {
  return Request(api.getProdCustomList, api.getProdCustomList.url, data, params);
}
// 产品新增
export function productEdit(params) {
  return Request(api.productEdit, api.productEdit.url, params).then((res) => {
    return res;
  });
}

// 产品编辑
export function productUpdate(params) {
  return Request(api.productUpdate, api.productUpdate.url, params).then((res) => {
    return res;
  });
}

// 分类列表
export function categoryList(params) {
  return Request(api.categoryList, api.categoryList.url, params).then((res) => {
    return res;
  });
}

// 行业列表
export function industryList(params) {
  return Request(api.industryList, api.industryList.url, params).then((res) => {
    return res;
  });
}

// 功能版本列表
export function functionverList(params) {
  return Request(api.functionverList, api.functionverList.url, params).then((res) => {
    return res;
  });
}

// 校验标识符在产品中是否唯一
export function validityProductIdentifier(params) {
  return Request(api.validityProductIdentifier, api.validityProductIdentifier.url, params, {
    hideError: true
  }).then((res) => {
    return res;
  });
}

// 校验名称在产品中是否唯一
export function validityProductName(params) {
  return Request(api.validityProductName, api.validityProductName.url, params, {
    hideError: true
  }).then((res) => {
    return res;
  });
}

// 产品版本审核
export function productVerAudit(params) {
  return Request(api.productVerAudit, api.productVerAudit.url, params).then((res) => {
    return res;
  });
}

// 产品版本审核记录
export function verAuditRecord(productVerId) {
  return Request(api.verAuditRecord, `${api.verAuditRecord.url}/${productVerId}`).then((res) => {
    return res;
  });
}

// 产品版本撤销发布
export function revokeReleased(productVerId) {
  return Request(api.revokeReleased, `${api.revokeReleased.url}/${productVerId}`).then((res) => {
    return res;
  });
}

// 产品完整json查看
export function customJsonFile(params) {
  return Request(api.customJsonFile, api.customJsonFile.url, params).then((res) => {
    return res;
  });
}
export function standardJsonFile(params) {
  return Request(api.standardJsonFile, api.standardJsonFile.url, params).then((res) => {
    return res;
  });
}

// 产品元件列表查询
export function getPrdMeta(productVerId) {
  return Request(api.getPrdMeta, `${api.getPrdMeta.url}/${productVerId}`).then((res) => {
    return res;
  });
}

// 产品版本录入人列表查询
export function getCreateUsers(instanceId) {
  return Request(api.getCreateUsers, api.getCreateUsers.url + instanceId);
}

// 产品版本发布人列表查询
export function getReleasedUsers(instanceId) {
  return Request(api.getReleasedUsers, api.getReleasedUsers.url + instanceId);
}

// 修改历史
export function getEditHistory(params) {
  return Request(api.getEditHistory, api.getEditHistory.url, params).then((res) => {
    return res;
  });
}
